import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';
import AnimateHeight from 'react-animate-height';
import classNames from 'classnames';

import { serializeImage } from '../../utils/SerializeImage';
import BackgroundImage from '../BackgroundImage';
import styles from './AuthorCard.module.scss';

const AuthorCard = ({ href, image, name, text }) => {
    const { t } = useTranslation('common');
    const serializedImage = serializeImage(image);
    const [expanded, setExpanded] = useState(false);
    const itemContainerRef = useRef(null);

    const toggleExpanded = () => setExpanded(!expanded);

    const classes = classNames(styles['AuthorCard'], {
        [styles['AuthorCard--expanded']]: expanded,
    });

    return (
        <div className={classes}>
            <a className={styles['AuthorCard__Link']} href={href}>
                <span className="sr-only">{name}</span>
            </a>
            <div className={styles['AuthorCard__Container']}>
                <div className={styles['AuthorCard__Image']}>
                    {serializedImage && (
                        <BackgroundImage {...serializedImage} quality={60} />
                    )}
                </div>
                <div className={styles['AuthorCard__Content']}>
                    <span className={styles['AuthorCard__Tag']}>
                        {t('author.tag')}
                    </span>
                    <h3 className={styles['AuthorCard__Title']}>{name}</h3>
                    <p className={styles['AuthorCard__Text']}>{text}</p>
                    <AnimateHeight
                        duration={350}
                        height={expanded ? 'auto' : 0}>
                        <div
                            id={'author-text'}
                            className={styles['AuthorCard__ExpandableText']}
                            role="region"
                            ref={itemContainerRef}>
                            {text}
                        </div>
                    </AnimateHeight>
                    <button
                        className={styles['AuthorCard__Toggle']}
                        onClick={toggleExpanded}
                        aria-controls={'author-text'}
                        aria-expanded={expanded}
                        aria-haspopup="true"
                        aria-label={
                            expanded ? t('author.close') : t('author.open')
                        }></button>
                </div>
            </div>
        </div>
    );
};

AuthorCard.propTypes = {
    href: PropTypes.string,
    image: PropTypes.object,
    name: PropTypes.string,
    text: PropTypes.string,
};

AuthorCard.defaultProps = {
    href: '',
    image: {},
    name: '',
    text: '',
};

export default AuthorCard;
